import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import AllRoleButton from '../../../../components/buttons/AllRoleButton';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useEffect, useState } from 'react';
import { ChipSelect } from '../../../../components/inputs/ChipSelect';
import {
  getAllCategories,
  getAllSkills,
  getAllMunicipalities,
  getAllEthnicities,
  getAllHealthConditions,
} from '../../../../store/actions/actions';

export const MentorFilter = ({
  categoryChips,
  setCategoryChips,
  skillChips,
  setSkillChips,
  municipalityChips,
  setMunicipalityChips,
  genderChips,
  setGenderChips,
  ethnicityChips,
  setEthnicityChips,
  healthConditionChips,
  setHealthConditionChips,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [selectedMunicipality, setSelectedMunicipality] = useState('choose');
  const [selectedGender, setSelectedGender] = useState('choose');
  const [selectedEthnicity, setSelectedEthnicity] = useState('choose');
  const [selectedHealthCondition, setSelectedHealthCondition] = useState('choose');
  const [selectedSkill, setSelectedSkill] = useState('choose');
  const [selectedCategory, setSelectedCategory] = useState('choose');

  const categoriesResponse = useSelector(({ categories }) => categories.getAll);
  const skillsResponse = useSelector(({ skills }) => skills.getAll);
  const municipalitiesResponse = useSelector(({ municipalities }) => municipalities.getAll);
  const ethnicitiesResponse = useSelector(({ ethnicities }) => ethnicities.getAll);
  const healthConditionsResponse = useSelector(({ healthConditions }) => healthConditions.getAll);
  const language = useSelector((state) => state.language);

  useEffect(() => {
    dispatch(getAllCategories({ pagination: false, language }));
    dispatch(getAllSkills({ pagination: false, language }));
    dispatch(getAllMunicipalities({ pagination: false, language }));
    dispatch(getAllEthnicities({ pagination: false, language }));
    dispatch(getAllHealthConditions({ pagination: false, language }));
  }, []);

  const onCategoryChange = (category, type) => {
    switch (type) {
      case 'add':
        const exists = categoryChips.find((chip) => chip._id === category._id);
        if (exists) return;

        const addedArray = [...categoryChips, category];
        setCategoryChips(addedArray);
        setSelectedCategory(category._id);
        break;
      case 'delete':
        const filteredArray = categoryChips.filter((chip) => chip._id !== category._id);
        setCategoryChips(filteredArray);
        setSelectedCategory('choose');
        break;
      default:
        break;
    }
  };
  const onSkillChange = (skill, type) => {
    switch (type) {
      case 'add':
        const exists = skillChips.find((chip) => chip._id === skill._id);
        if (exists) return;

        const addedArray = [...skillChips, skill];
        setSkillChips(addedArray);
        setSelectedSkill(skill._id);
        break;
      case 'delete':
        const filteredArray = skillChips.filter((chip) => chip._id !== skill._id);
        setSkillChips(filteredArray);
        setSelectedSkill('choose');
        break;
      default:
        break;
    }
  };
  const onMunicipalityChange = (municipality, type) => {
    switch (type) {
      case 'add':
        const exists = municipalityChips.find((chip) => chip._id === municipality._id);
        if (exists) return;

        const addedArray = [...municipalityChips, municipality];
        setMunicipalityChips(addedArray);
        setSelectedMunicipality(municipality._id);
        break;
      case 'delete':
        const filteredArray = municipalityChips.filter((chip) => chip._id !== municipality._id);
        setMunicipalityChips(filteredArray);
        setSelectedMunicipality('choose');
        break;
      default:
        break;
    }
  };
  const onGenderChange = (gender, type) => {
    switch (type) {
      case 'add':
        const exists = genderChips.find((chip) => chip._id === gender._id);
        if (exists) return;

        const addedArray = [...genderChips, gender];
        setGenderChips(addedArray);
        setSelectedGender(gender._id);
        break;
      case 'delete':
        const filteredArray = genderChips.filter((chip) => chip._id !== gender._id);
        setGenderChips(filteredArray);
        setSelectedGender('choose');
        break;
      default:
        break;
    }
  };

  const onEthnicityChange = (ethnicity, type) => {
    switch (type) {
      case 'add':
        const exists = ethnicityChips.find((chip) => chip === ethnicity);
        if (exists) return;

        const addedArray = [...ethnicityChips, ethnicity];
        setEthnicityChips(addedArray);
        setSelectedEthnicity(ethnicity);
        break;
      case 'delete':
        const filteredArray = ethnicityChips.filter((chip) => chip !== ethnicity);
        setEthnicityChips(filteredArray);
        setSelectedEthnicity('choose');
        break;
      default:
        break;
    }
  };

  const onHealthConditionChange = (healthCondition, type) => {
    switch (type) {
      case 'add':
        const exists = healthConditionChips.find((chip) => chip === healthCondition);
        if (exists) return;

        const addedArray = [...healthConditionChips, healthCondition];
        setHealthConditionChips(addedArray);
        setSelectedHealthCondition(healthCondition);
        break;
      case 'delete':
        const filteredArray = healthConditionChips.filter((chip) => chip !== healthCondition);
        setHealthConditionChips(filteredArray);
        setSelectedHealthCondition('choose');
        break;
      default:
        break;
    }
  };

  const resetFilters = () => {
    setSelectedMunicipality('choose');
    setSelectedGender('choose');
    setSelectedEthnicity('choose');
    setSelectedHealthCondition('choose');
    setSelectedSkill('choose');
    setSelectedCategory('choose');
    setMunicipalityChips([]);
    setCategoryChips([]);
    setEthnicityChips([]);
    setGenderChips([]);
    setHealthConditionChips([]);
    setSkillChips([]);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="ethnicity"
              label={t('ethnicity')}
              selectLabel={t('chooseEthnicity')}
              handleChange={(e) => onEthnicityChange(JSON.parse(e.target.value), 'add')}
              value={selectedEthnicity}
              data={
                ethnicitiesResponse?.success && ethnicitiesResponse.data?.ethnicities?.docs
                  ? ethnicitiesResponse.data.ethnicities.docs
                  : []
              }
              valueChips={ethnicityChips}
              handleDelete={onEthnicityChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="healthCondition"
              label={t('healthConditions')}
              selectLabel={t('chooseHealthCondition')}
              handleChange={(e) => onHealthConditionChange(JSON.parse(e.target.value), 'add')}
              value={selectedHealthCondition}
              data={
                healthConditionsResponse?.success && healthConditionsResponse.data?.healthconditions?.docs
                  ? healthConditionsResponse.data.healthconditions.docs
                  : []
              }
              valueChips={healthConditionChips}
              handleDelete={onHealthConditionChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="gender"
              label={t('gender')}
              selectLabel={t('gender')}
              handleChange={(e) => onGenderChange(JSON.parse(e.target.value), 'add')}
              value={selectedGender}
              data={[
                { _id: 'M', label: t('gender1') },
                { _id: 'F', label: t('gender2') },
                { _id: 'O', label: t('gender3') },
              ]}
              valueChips={genderChips}
              handleDelete={onGenderChange}
              ignoreLoc={true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="categories"
              label={t('filter-interest')}
              selectLabel={t('chooseCategories')}
              handleChange={(e) => onCategoryChange(JSON.parse(e.target.value), 'add')}
              value={selectedCategory}
              data={
                categoriesResponse?.success && categoriesResponse.data?.categories?.docs
                  ? categoriesResponse.data.categories.docs
                  : []
              }
              valueChips={categoryChips}
              handleDelete={onCategoryChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="skills"
              label={t('filter-skills')}
              selectLabel={t('chooseSkills')}
              handleChange={(e) => onSkillChange(JSON.parse(e.target.value), 'add')}
              value={selectedSkill}
              data={skillsResponse?.success && skillsResponse.data?.skills?.docs ? skillsResponse.data.skills.docs : []}
              valueChips={skillChips}
              handleDelete={onSkillChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ChipSelect
              name="municipalities"
              label={t('Komuna')}
              selectLabel={t('ChooseMunicipality')}
              handleChange={(e) => onMunicipalityChange(JSON.parse(e.target.value), 'add')}
              value={selectedMunicipality}
              data={
                municipalitiesResponse?.success && municipalitiesResponse.data?.municipalities?.docs
                  ? municipalitiesResponse.data.municipalities.docs
                  : []
              }
              valueChips={municipalityChips}
              handleDelete={onMunicipalityChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mt: { md: 3.5, lg: 3.6, xl: 3.6 } }}>
            <AllRoleButton
              label={t('resetFilters')}
              handleClick={() => resetFilters()}
              backgroundColor={'#F36E21'}
              icon={<RemoveCircleOutlineIcon />}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
